import { render, staticRenderFns } from "./FTPS.vue?vue&type=template&id=b47d8846&"
import script from "./FTPS.vue?vue&type=script&lang=js&"
export * from "./FTPS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports